<template>
<div class="">
<user-top></user-top>
<div class="millia">
<div class="ht tc mt50">我申请的职位</div>
<ul class="myList">
<li v-for="list in myApply" :key="list.id">
<p><b>部门：</b>{{list.dept_name}}</p>
<p><b>职位：</b>{{list.position_title}}</p>
<p><b>时间：</b>{{list.create_time}}</p>
<p><b>状态：</b>{{list.status_text}}</p>
<p><b>成绩：</b><i>{{list.score}}</i></p>
<p v-if="list.refuse_reason != ''"><b>意见：</b>
<span v-for="items in list.refuse_reason" :key="items.id">{{items}}</span>
</p>
<!--<p><a target="_blank" href="https://api.jiaodong.net/ytgdzk/public/downLoad/passCheck.pdf" class="layui-btn layui-btn-danger layui-btn-fluid">考试通行证下载</a></p>-->
<p v-if="list.status ===2&& list.pdf_url != ''"><a target="_blank" :href="list.pdf_url" :download="list.pdf_url" class="layui-btn layui-btn-danger layui-btn-fluid">报名表下载</a></p>
<p v-if="list.status ===2&& list.ticket_url != ''"><a target="_blank" :href="list.ticket_url" :download="list.ticket_url" class="layui-btn layui-btn-danger layui-btn-fluid">准考证下载</a></p>
<p v-if="list.status !=2">
<router-link to="/SaveApply" tag="a" class="layui-btn layui-btn-fluid">修改报考岗位</router-link>
</p>
</li>
</ul>
<div v-show="ishide" class="blueBg">
<div class="ht01">基本信息</div>
<ul class="infoList">
<li><label>姓名：</label>{{allData.realname}}</li>
<li><label>照片：</label><img :src="img_url" class="userImg"></li>
<li><label>性别：</label>{{allData.sex_text}}</li>
<li><label>身份证号码：</label>{{allData.id_card}}</li>
<!--<li><label>民族：</label>{{allData.nation_text}}</li>-->
<li><label>政治面貌：</label>{{allData.political_status_text}}</li>
<!--<li><label>身份类型：</label>{{allData.user_type_text}}</li>-->
<li><label>学历：</label>{{allData.education_text}}</li>
<li><label>学位：</label>{{allData.degree_text}}</li>
<li><label>专业：</label>{{allData.major}}</li>
<li><label>毕业学校：</label>{{allData.graduated_school}}</li>
<li><label>毕业时间：</label>{{allData.graduated_time}}</li>
<li><label>工作时间：</label>{{allData.work_time}}</li>
<!--<li><label>工作单位：</label>{{allData.employer}}</li>-->
<li><label>户籍所在地：</label>{{allData.household}}</li>
<!--<li><label>其他说明：</label>{{allData.other}}</li>-->
</ul>
<div class="ht01 mt20">教育经历</div>
<ul class="expList">
<li v-for="(eduLists,id) of eduList" :key="id" :id="eduLists.id">
<p><label>学校名称：</label>{{eduLists.school_name}}</p>
<p><label>所获学历：</label>{{eduLists.education_text}}</p>
<p><label>专业：</label>{{eduLists.major}}</p>
<p><label>开始时间：</label>{{eduLists.start_time}}</p>
<p><label>结束时间：</label>{{eduLists.end_time}}</p>
</li>
</ul>
<div class="ht01 mt20">工作经历</div>
<ul class="expList">
<li v-for="(jobLists,id) of jobList" :key="id" :id="jobLists.id">
<p><label>公司名称：</label>{{jobLists.company_name}}</p>
<p><label>岗位：</label>{{jobLists.position}}</p>
<p><label>开始时间：</label>{{jobLists.start_time}}</p>
<p><label>离职时间：</label>{{jobLists.end_time}}</p>
<p><label>岗位说明：</label>{{jobLists.work_exp}}</p>
</li>
</ul>
<div class="ht01 mt20">家庭关系</div>
<ul class="expList">
<li v-for="(familyLists,id) of familyList" :key="id" :id="familyLists.id">
<p><label>姓名：</label>{{familyLists.realname}}</p>
<p><label>手机号码：</label>{{familyLists.phone}}</p>
<p><label>成员关系：</label>{{familyLists.relation}}</p>
<p><label>工作单位：</label>{{familyLists.work_add}}</p>
</li>
</ul>
</div>
<div class="blueBg returnInfo" v-show="isshow">
您还没有申请任何职位
<p><router-link to="SaveApply" tag="a">去申请职位</router-link></p>
</div>
</div>
<br />
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
export default {
    name: 'UserInfo',
    components: {
        UserTop
    },
    data () {
        return {
            myApply:{},//我申请的职位
            allData:{},//用户所有资料
            img_url:"",//用户头像地址
            eduList:[],//教育经历
            jobList:[],//工作经历
            familyList:[],//家庭关系
            ishide:false,//是否申请岗位显示用户所有信息
            isshow:true,//是否申请岗位提示用户去申请岗位
        }
    },
    mounted(){
        //this.GetMyApply();
    },
    methods: {
        //获取申请记录
        GetMyApply() {
            let url = "api/apply/getMyApply";
            let params = {}
            this.$ajax.get(url, params).then(function (response) {
            console.log(response.data.data)
                if (response.data.status==1) {
                    this.myApply = response.data.data;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        //获取申请岗位时用户信息所有详情
        getallData(id){
            let url = "api/user/getUserInfo";
            let params = {
                apply_id:id
            }
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.allData = response.data.data;
                    this.img_url = response.data.data.img_url;
                    this.eduList = response.data.data.edu_exp;
                    this.jobList = response.data.data.work_exp;
                    this.familyList = response.data.data.family;
                    //console.log(this.allData);
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
    },
    beforeMount(){
        this.GetMyApply();
    },
    watch:{
       myApply(newAllData,oldAllData){
            if (JSON.stringify(this.myApply) === '[]') {
                console.log("没有获取到用户已填信息");
            }else{
                console.log("获取到用户已填信息");
                //console.log(this.myApply);
                this.getallData();
                this.ishide = true;
                this.isshow = false;
            }
       }
    }
}
</script>
<style scoped>
.ht01{font-size:1.5rem;padding:1rem 0;color:#3fa6e3;border-bottom:.1rem solid #99D3F5;margin-bottom:2rem;font-weight:bold;}
.myList li,.blueBg{padding-bottom:1rem;font-size:1.4rem;color:#333;background:#D0EEFF;border:.1rem solid #99D3F5;border-radius:1rem;padding:1.5rem;margin-bottom:1rem;}
.myList li p{display:flex;align-items:flex-start;}
.myList li b{display:inline-block;color:#3fa6e3;font-weight:normal;white-space:nowrap;}
/*.myList p{padding:1rem 0 0 4.5rem;position:relative;}*/
.myList p{display:flex;align-items:center;padding:0.5rem 0;}
/*.myList p b{display:block;position:absolute;left:0;top:1rem;}*/
.myList p span{display:block;padding-bottom:.8rem;font-size:1.4rem;color:#333;margin:0;}
.myList li p span:last-child{padding:0;}
.myList li p:last-child{padding-bottom:.5rem;}
.infoList li{padding-bottom:1rem;font-size:1.4rem;color:#333;}
.infoList li label,.expList li p label{display:inline-block;padding-right:1rem;font-size:1.4rem;color:#3fa6e3;font-weight:normal;}
.expList li{border-bottom:.1rem dotted #d0d0d0;font-size:1.4rem;color:#333;position:relative;}
.expList li:last-child{border:none;}
.expList li p{padding-bottom:1rem;}
.userImg{width:10rem;height:auto;border:1px solid #3fa6e3;}
.returnInfo{text-align:center;font-size:1.4rem;}
.returnInfo p{font-size:1.6rem;font-weight:bold;padding-top:1rem;color:#3fa6e3;}
.returnInfo p a{color:#3fa6e3;}

</style>

